import { render, staticRenderFns } from "./IndexPurchases.vue?vue&type=template&id=2ca9f92a&scoped=true&"
import script from "./IndexPurchases.vue?vue&type=script&lang=js&"
export * from "./IndexPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9f92a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
